/* tslint:disable:max-line-length */
import { CommonModule as AngularCommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
// import { MomentModule } from 'ngx-moment';
import { SwiperModule } from 'swiper/angular';
import { Calendar } from '@awesome-cordova-plugins/calendar/ngx';
import { AvatarComponent } from './avatar/avatar.component';
import { BepatientHtmlComponent } from './bepatient-html/bepatient-html.component';
import { BurgerButtonComponent } from './burger-button/burger-button.component';
import { AddRtlClassDirective } from './directives/add-rtl-class.directive';
import { AdjustSizeIfKeyboardIsOpenDirective } from './directives/adjust-size-if-keyboard-is-open.directive';
import { ApplyInstanceColorDirective } from './directives/apply-instance-color.directive';
import { DisplayIfCanGoBackDirective } from './directives/display-if-can-go-back.directive';
import { DisplayIfKeyboardIsClosedDirective } from './directives/display-if-keyboard-is-closed.directive';
import { DisplayIfStackOfResourcesDirective } from './directives/display-if-stack-of-resources.directive';
import { DynamicFormQuestionComponent } from './dynamic-form-builder/dynamic-form/dynamic-form-question/dynamic-form-question.component';
import { FieldNestedGroupComponent } from './dynamic-form-builder/dynamic-form/dynamic-form-question/field-nested-group/field-nested-group.component';
import { InputCheckboxComponent } from './dynamic-form-builder/dynamic-form/dynamic-form-question/input-checkbox/input-checkbox.component';
import { InputDatetimeComponent } from './dynamic-form-builder/dynamic-form/dynamic-form-question/input-datetime/input-datetime.component';
import { InputDropdownComponent } from './dynamic-form-builder/dynamic-form/dynamic-form-question/input-dropdown/input-dropdown.component';
import { InputRadioComponent } from './dynamic-form-builder/dynamic-form/dynamic-form-question/input-radio/input-radio.component';
import { InputRangeComponent } from './dynamic-form-builder/dynamic-form/dynamic-form-question/input-range/input-range.component';
import { InputTextComponent } from './dynamic-form-builder/dynamic-form/dynamic-form-question/input-text/input-text.component';
import { InputTexteareaComponent } from './dynamic-form-builder/dynamic-form/dynamic-form-question/input-textearea/input-textearea.component';
import { InputToggleComponent } from './dynamic-form-builder/dynamic-form/dynamic-form-question/input-toggle/input-toggle.component';
import { DynamicFormComponent } from './dynamic-form-builder/dynamic-form/dynamic-form.component';
import { DynamicFormQuestionControlService } from './dynamic-form-builder/question-control.service';
import { DynamicFormQuestionParserService } from './dynamic-form-builder/question-parser.service';
import { DynamicFormV3Module } from './dynamic-form-v3/dynamic-form-v3.module';
import { DynamicHeaderComponent } from './dynamic-header/dynamic-header.component';
import { DynamicIconComponent } from './dynamic-icon/dynamic-icon.component';
import { EmptyStateComponent } from './empty-state/empty-state.component';
import { FixedCloseButtonComponent } from './fixed-close-button/fixed-close-button.component';
import { LogoHolderComponent } from './instance/logo-holder/logo-holder.component';
import { PrivacyContentComponent } from './instance/privacy-content/privacy-content.component';
import { TextHolderComponent } from './instance/text-holder/text-holder.component';
import { MeasureListHeaderComponent } from './measures/measure-list-header/measure-list-header.component';
import { MeasureTileComponent } from './measures/measure-tile/measure-tile.component';
import { OnboardingButtonV2Component } from './onboarding/button-v2/onboarding-button-v2.component';
import { OnboardingButtonComponent } from './onboarding/button/onboarding-button.component';
import { OnboardingInputRadioComponent } from './onboarding/input-radio/onboarding-input-radio.component';
import { OnboardingInputTextComponent } from './onboarding/input-text/onboarding-input-text.component';
import { OnboardingNavigationButtonComponent } from './onboarding/navigation-button/onboarding-navigation-button.component';
import { OnboardingSubtitleComponent } from './onboarding/subtitle/onboarding-subtitle.component';
import { OnboardingTitleComponent } from './onboarding/title/onboarding-title.component';
import { ProgressIconComponent } from './progress-icon/progress-icon.component';
import { CommonUtilsService } from './services/common-utils.service';
import { ToggleButtonComponent } from './toggle-button/toggle-button.component';
import { TosDetailsComponent } from './tos/details/tos-details.component';
import { TosSummaryComponent } from './tos/summary/tos-summary.component';
import { UserPasswordComponent } from './user-password/user-password.component';
import { BepatientSkeletonComponent } from './bepatient-skeleton/bepatient-skeleton.component';
import { BepatientImageComponent } from './bepatient-image/bepatient-image.component';
import { MyAccountButtonComponent } from './my-account-button/my-account-button.component';
import { MainButtonComponent } from './dynamic-menu/main-button/main-button.component';
import { MainIconComponent } from './dynamic-menu/main-icon/main-icon.component';
import { SecondaryButtonComponent } from './dynamic-menu/menu-secondary-button/secondary-button.component';
import { SecondaryButtonContainerComponent } from './dynamic-menu/menu-secondary-button-container/secondary-button-container.component';
import { QuickTourComponent } from './quick-tour/quick-tour.component';
import { PhoneCheckModalComponent } from './phone-check/phone-check.component';
import { ThemeSwitcherComponent } from './theme-switcher/theme-switcher.component';
import { ThemeColorPipe } from './pipes/theme-color.pipe';

/* tslint:enable:max-line-length */

@NgModule({
  imports: [
    IonicModule,
    // MomentModule,
    AngularCommonModule,
    DynamicFormV3Module,
    ReactiveFormsModule,
    FormsModule,
    TranslateModule.forChild(),
    SwiperModule
  ],
  providers: [
    Calendar,
    CommonUtilsService,
    DynamicFormQuestionParserService,
    DynamicFormQuestionControlService
  ],
  declarations: [
    DynamicFormComponent,
    DynamicFormQuestionComponent,
    InputTextComponent,
    InputDropdownComponent,
    InputRangeComponent,
    InputToggleComponent,
    InputCheckboxComponent,
    InputRadioComponent,
    InputDatetimeComponent,
    FieldNestedGroupComponent,
    ToggleButtonComponent,
    InputTexteareaComponent,
    UserPasswordComponent,
    OnboardingInputTextComponent,
    OnboardingSubtitleComponent,
    OnboardingButtonComponent,
    DisplayIfCanGoBackDirective,
    OnboardingInputRadioComponent,
    OnboardingTitleComponent,
    DynamicHeaderComponent,
    BurgerButtonComponent,
    ApplyInstanceColorDirective,
    TosDetailsComponent,
    TosSummaryComponent,
    OnboardingNavigationButtonComponent,
    DynamicIconComponent,
    EmptyStateComponent,
    DisplayIfKeyboardIsClosedDirective,
    AdjustSizeIfKeyboardIsOpenDirective,
    FixedCloseButtonComponent,
    MeasureListHeaderComponent,
    MeasureTileComponent,
    ProgressIconComponent,
    AddRtlClassDirective,
    BepatientHtmlComponent,
    AvatarComponent,
    DisplayIfStackOfResourcesDirective,
    LogoHolderComponent,
    PrivacyContentComponent,
    TextHolderComponent,
    OnboardingButtonV2Component,
    BepatientSkeletonComponent,
    BepatientImageComponent,
    MyAccountButtonComponent,
    MainButtonComponent,
    MainIconComponent,
    SecondaryButtonComponent,
    SecondaryButtonContainerComponent,
    QuickTourComponent,
    PhoneCheckModalComponent,
    ThemeSwitcherComponent,
    ThemeColorPipe
  ],
  exports: [
    DynamicFormV3Module,
    SwiperModule,
    ToggleButtonComponent,
    DynamicFormComponent,
    DynamicFormQuestionComponent,
    InputTextComponent,
    InputDropdownComponent,
    InputRangeComponent,
    InputToggleComponent,
    InputCheckboxComponent,
    InputRadioComponent,
    InputDatetimeComponent,
    FieldNestedGroupComponent,
    UserPasswordComponent,
    OnboardingInputTextComponent,
    OnboardingSubtitleComponent,
    OnboardingButtonComponent,
    DisplayIfCanGoBackDirective,
    OnboardingInputRadioComponent,
    OnboardingTitleComponent,
    DynamicHeaderComponent,
    BurgerButtonComponent,
    ApplyInstanceColorDirective,
    TosDetailsComponent,
    TosSummaryComponent,
    OnboardingNavigationButtonComponent,
    DynamicIconComponent,
    EmptyStateComponent,
    DisplayIfKeyboardIsClosedDirective,
    AdjustSizeIfKeyboardIsOpenDirective,
    FixedCloseButtonComponent,
    MeasureListHeaderComponent,
    MeasureTileComponent,
    ProgressIconComponent,
    AddRtlClassDirective,
    BepatientHtmlComponent,
    AvatarComponent,
    DisplayIfStackOfResourcesDirective,
    LogoHolderComponent,
    PrivacyContentComponent,
    TextHolderComponent,
    OnboardingButtonV2Component,
    BepatientSkeletonComponent,
    BepatientImageComponent,
    MyAccountButtonComponent,
    MainButtonComponent,
    MainIconComponent,
    SecondaryButtonComponent,
    SecondaryButtonContainerComponent,
    PhoneCheckModalComponent,
    ThemeSwitcherComponent,
    ThemeColorPipe
  ]
})
export class CommonModule {}
